import { getSelector } from '@carboncopyco/editor-utils';
import type { Modification, Selector } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { RuleIcon } from '../RuleIcon';
import { RulePreview } from '../RulePreview';
import { navigationRuleOptions } from './navigation-rules-selection-options';

export type NavigationRulePreviewProps = {
  rule: Modification<'block_interactions' | 'replace_link'>;
};

const getLabelBySelector = (selector: Selector): string => {
  const selectorType = selector.type;
  if (selectorType === 'anchor_href') {
    return `Block ${selector.arguments.url}`;
  }
  if (selectorType === 'text_content') {
    return `Block ”${selector.arguments.text}”`;
  }
  return 'Block';
};

export const NavigationRulePreview = ({ rule }: NavigationRulePreviewProps) => {
  const selector =
    getSelector(rule.selectors, 'anchor_href') ||
    getSelector(rule.selectors, 'text_content');

  const label = getLabelBySelector(selector);
  const navigationRuleConfig = navigationRuleOptions.find(
    (ruleSelectionOption) => ruleSelectionOption.value === rule.schemaType
  );
  return (
    <RulePreview>
      <div className="shrink-0">
        <RuleIcon>{navigationRuleConfig.icon}</RuleIcon>
      </div>
      <Text label={label} />
    </RulePreview>
  );
};

const Text = ({ label }: { label: string }) => (
  <RulePreview.Tooltip title={label}>
    <span className="truncate">
      <TextBase
        label={label}
        color="text-ds-natural-600"
        ellipsis
      />
    </span>
  </RulePreview.Tooltip>
);
